exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreeWrap[data-v-25dcebf8]{font-size:.293333rem;padding:.8rem;line-height:.506667rem;background:#fff;min-height:100vh;height:auto}.agreeWrap h1[data-v-25dcebf8]{font-size:.373333rem}.agreeWrap h6[data-v-25dcebf8]{padding:.2rem 0;font-size:.7rem}.agreeWrap li[data-v-25dcebf8]{margin:.5rem 0}.textIndet10[data-v-25dcebf8]{text-indent:.133333rem}.textIndet20[data-v-25dcebf8]{text-indent:.266667rem}", ""]);

// exports
